module.exports = __webpack_public_path__ + "img/client-5.jpg?7dc4ebf638633b4d621e156addb77d55";